// extracted by mini-css-extract-plugin
export default {"DeleteApprovedContentsDialog":"DeleteApprovedContentsDialog_DeleteApprovedContentsDialog__rPJSH"};